/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useContext, useCallback } from "react";
import { ThemeContext } from "../../../../../../contexts";
import { api } from "../../../../../../utils/api";
import { useNavigate } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import useRouteParam from "../../../../../../hooks/useRouteParam";
import ExtractRouteQueryParams from "../../../../../../utils/commonFunctions/extractRouteQueryParams";
import ApproveActiveEnrollment from "../../../../../shared/approveActiveEnrollment/ApproveActiveEnrollment";
import KsopHeaderInformation from "../ksopHeaderInformation/KsopHeaderInformation";
import KsopPersonalInformation from "../ksopPersonalInformation/KsopPersonalInformation";
import KsopBeneficiaryDesignation from "../ksopBeneficiaryDesignation/KsopBeneficiaryDesignation";
import KsopNameChange from "../ksopNameChange/KsopNameChange";
import KsopPartcipantSignature from "../ksopPartcipantSignature/KsopPartcipantSignature";
import KsopBeneficiaryName from "../ksopBeneficiaryName/KsopBeneficiaryName";

import { Grid, Button } from "@material-ui/core";

import SendIcon from "@material-ui/icons/Send";

import "./ksopFormActual.css";

const KsopFormActual = ({
	enrollments,
	enrollmentStatus,
	effectiveDate,
	enrollmentDate,
	handleApproveEffectiveDateChange,
	planName
}) => {
	const { theme } = useContext(ThemeContext);
	const queryEnrollmentId = useRouteParam("eid");
	const routeQueryParam = ExtractRouteQueryParams().join("&");
	const navigate = useNavigate();

	const handleRedirectToMemberDetails = useCallback(() => {
		const pathname = `/employer/member?${routeQueryParam}`;
		navigate(pathname);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSubmitEnrollmentClick = useCallback(async () => {
		if (!queryEnrollmentId) return;
		if (!effectiveDate) {
			alert("Effective date is required");
			return;
		}
		try {
			const payload = {
				_id: queryEnrollmentId,
				plan_name: planName,
				effective_date: effectiveDate
			};
			const response = await trackPromise(api.enrollments.AddAutoApproveEnrollment(payload));
			if (response) {
				alert("Auto Approve Enrollment Added Succesfully!");
				handleRedirectToMemberDetails();
			}
		} catch (error) {
			alert("Auto Approve Enrollment Submission unsuccessful!");
			throw error;
		}
	}, [effectiveDate, planName, queryEnrollmentId, handleRedirectToMemberDetails]);

	// console.log("==========enrollments========", enrollments.primary_beneficiery);

	return (
		<div className="ksop-container">
			<div className="ksop-header-information" id="ksop-header-information">
				<KsopHeaderInformation />
			</div>
			<div className="ksop-personal-information" id="ksop-personal-information">
				{enrollments?.employee ? <KsopPersonalInformation employeeDetails={enrollments.employee} /> : null}
			</div>
			<div className="ksop-beneficiary-designation">
				{enrollments?.KSOP_option ? (
					<KsopBeneficiaryDesignation KSOP_option_props={enrollments.KSOP_option} />
				) : null}
			</div>
			<div className="ksop-beneficiary-name" id="ksop-beneficiary-name">
				{enrollments && enrollments?.primary_beneficiery ? (
					<KsopBeneficiaryName
						// primaryBeneficiary={primaryBeneficiary}
						// contingentBeneficiary={contingentBeneficiary}
						primaryBeneficiary={enrollments?.primary_beneficiery}
						contingentBeneficiary={enrollments?.contingent_beneficiery}
					/>
				) : null}
			</div>
			{/* <div className="ksop-name-change" id="ksop-name-change">
				<KsopNameChange />
			</div> */}
			<div className="ksop-participant-signature" id="ksop-participant-signature">
				{enrollments ? (
					<KsopPartcipantSignature employeeDetails={enrollments?.employee} enrollments={enrollments} />
				) : null}
			</div>
			<div className="buttom-flex">
				<p>GP 24488-26</p>
				<div>
					<p style={{ textAlign: "center" }}>Please retain a copy for your records</p>
					<p>
						<b>THIS FORM MUST BE RETURNED TO THE BENEFITS DEPARTMENT</b>
					</p>
				</div>
				<p>05/2008</p>
			</div>
			<div className="approve-active-enrollment">
				<ApproveActiveEnrollment
					enrollmentDate={enrollmentDate}
					enrollmentStatus={enrollmentStatus}
					effectiveDate={effectiveDate}
					handleApproveEffectiveDateChange={handleApproveEffectiveDateChange}
				/>
			</div>
			<div className="theme-plan-section-margin" />
			<Grid container>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
					<Button
						style={{
							backgroundColor: "#44b700",
							color: "#ffff "
						}}
						onClick={handleSubmitEnrollmentClick}
					>
						<span className="button-label-with-icon">Submit</span>
						<span>
							<SendIcon className="button-icon" />
						</span>
					</Button>
				</Grid>
				<Grid item xl={4} lg={4} md={4} sm={12} xs={12}></Grid>
			</Grid>
		</div>
	);
};

export default KsopFormActual;
